import { useCallback, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MapContext } from "../context/map.context";
//@ts-ignore
import Mazemap from "@itpi/mazemap";
import { LngLat } from "mapbox-gl";
import { Poi } from "../data/mazemap.api";

export const useEnableMapLocationClick = () => {
  const { map } = useContext(MapContext);
  const navigate = useNavigate();

  const handleMapClick = useCallback(
    ({ lngLat }: { lngLat: LngLat }) => {
      const zLevel = map.zLevel;
      Mazemap.Data.getPoiAt(lngLat, zLevel)
        .then((poi: Poi) => {
          navigate(`/location/poi/${poi.properties.poiId}`);
        })
        .catch(() => null);
    },
    [map, navigate]
  );

  useEffect(() => {
    if (map) {
      map.on("click", handleMapClick);
      return () => map.off("click", handleMapClick);
    }
  }, [map, handleMapClick]);
};
